import { configureStore } from '@reduxjs/toolkit';

/* Import state slices */
import layoutSlice from './layout/layout';
import authSlice from './auth/auth';
import globalFeedbackSlice from './globalFeedback/globalFeedback';
import manifestRecordSlice from './manifest/manifest';
import deliveryRunSheetRecordSlice from './deliveryRunSheet/deliveryRunSheet';

const store = configureStore({
    reducer: {
        layout: layoutSlice.reducer,
        auth: authSlice.reducer,
        globalFeedback: globalFeedbackSlice.reducer,
        manifest: manifestRecordSlice.reducer,
        deliveryRunSheet: deliveryRunSheetRecordSlice.reducer,
    },
});

export default store;